import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

const watchEntityKeys = ['providerServices', 'services']

function useProviderServices(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const { provider_id: filterProviderId } = filters || {}

  const {
    updatedEntities: {
      providerServices: providerServicesUpdatedAt,
      services: servicesUpdatedAt,
    },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingProviderServices } = useReduxAction(
    'providerServices',
    'loadProviderServices',
    {
      entityKey,
      ...filters,
    },
    [filters, performHttpRequests],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const { providerServices, services } = useSelector(reduxState => reduxState.entities)

  const filteredProviderServices = useMemo(() => {
    const filtered = Object.values(providerServices).filter((providerService) => {
      const { provider_id } = providerService

      const matchProviderId = matchFilterNumber(provider_id, filterProviderId)

      return matchProviderId
    })

    return sortArrayBy(filtered, 'asc', ({ service_id }) => services[service_id]?.title)
  }, [providerServicesUpdatedAt, servicesUpdatedAt, JSON.stringify(filters)])

  const hasFilteredProviderServices = !!filteredProviderServices.length

  return {
    filteredProviderServices,
    hasFilteredProviderServices,
    loading: loadingProviderServices,
  }
}

export default useProviderServices
